/* eslint-disable react-hooks/exhaustive-deps */
// ESLs.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, ESLsSquare, Infos } from "./styles";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import "material-symbols";
import api from "../../services/api";

import ButtonSequence from "../../components/ButtonSequence/ButtonSequence ";
import ButtonGrey from "../../components/ButtonGrey/ButtonGrey";
import Input from "../../components/Input/Input";

function ESLs() {
  const navigate = useNavigate();
  const businessUnitCodeURL = new URLSearchParams(useLocation().search).get(
    "businessUnitCode"
  ); // Pegar o businessUnitCode da URL
  const sectionURL = new URLSearchParams(useLocation().search).get("section"); // Pegar o section da URL

  const [eslsByShelf, setEslsByShelf] = useState([]);
  const [shelves, setShelves] = useState([]);
  const [status, setStatus] = useState("Carregando");
  const [filterVisible, setFilterVisible] = useState("none");

  const [gtin, setGtin] = useState("");
  const [mac, setMac] = useState("");

  const handleButtonClickShelf = (buttonNumberShelf) => {
    api
      .get(
        `/esls/details?businessUnitCode=${businessUnitCodeURL}&section=${sectionURL}&shelf=${buttonNumberShelf}`
      )
      .then((response) => {
        setStatus("Sucesso");
        setEslsByShelf(
          response.data.reduce((acc, cur) => {
            const level = cur.level.trim();
            const slot = cur.slot.trim();
            if (!acc[level]) {
              acc[level] = {};
            }
            if (!acc[level][slot]) {
              acc[level][slot] = [];
            }
            acc[level][slot].push(cur);
            return acc;
          }, {})
        );
      })
      .catch((error) => {
        setEslsByShelf([]);
        setStatus("Erro");
      });
  };

  useEffect(() => {
    if (gtin.length === 13) {
      handleSearchGtin();
    }
  }, [gtin]);

  function handleSearchGtin() {
    api
      .get(`/esls/details/gtin/${businessUnitCodeURL}/${sectionURL}/${gtin}`)
      .then((response) => {
        setEslsByShelf(
          response.data.reduce((acc, cur) => {
            const level = cur.level.trim();
            const slot = cur.slot.trim();
            if (!acc[level]) {
              acc[level] = {};
            }
            if (!acc[level][slot]) {
              acc[level][slot] = [];
            }
            acc[level][slot].push(cur);
            return acc;
          }, {})
        );
      })
      .catch((error) => {
        setEslsByShelf([]);
        setStatus("Erro");
      });
  }

  const handleClickNotCommissioned = () => {
    api
      .get(`/esls/details/notcommissioned/${businessUnitCodeURL}/${sectionURL}`)
      .then((response) => {
        setEslsByShelf(
          response.data.reduce((acc, cur) => {
            const level = cur.level.trim();
            const slot = cur.slot.trim();
            if (!acc[level]) {
              acc[level] = {};
            }
            if (!acc[level][slot]) {
              acc[level][slot] = [];
            }
            acc[level][slot].push(cur);
            return acc;
          }, {})
        );
      })
      .catch((error) => {
        setEslsByShelf([]);
        setStatus("Erro");
      });
  };

  const handleClickCommissioned = () => {
    api
      .get(`/esls/details/commissioned/${businessUnitCodeURL}/${sectionURL}`)
      .then((response) => {
        setEslsByShelf(
          response.data.reduce((acc, cur) => {
            const level = cur.level.trim();
            const slot = cur.slot.trim();
            if (!acc[level]) {
              acc[level] = {};
            }
            if (!acc[level][slot]) {
              acc[level][slot] = [];
            }
            acc[level][slot].push(cur);
            return acc;
          }, {})
        );
      })
      .catch((error) => {
        setEslsByShelf([]);
        setStatus("Erro");
      });
  };

  useEffect(() => {
    if (mac.length === 12) {
      handleSearchMac();
    }
  }, [mac]);

  function handleSearchMac() {
    console.log(mac);
    api.get(`/esls/details/${mac}`).then((response) => {
      setEslsByShelf(
        response.data.reduce((acc, cur) => {
          const level = cur.level.trim();
          const slot = cur.slot.trim();
          if (!acc[level]) {
            acc[level] = {};
          }
          if (!acc[level][slot]) {
            acc[level][slot] = [];
          }
          acc[level][slot].push(cur);
          return acc;
        }, {})
      );
    });
  }

  function inicialização() {
    api
      .get(
        `/physicalOrganization/shelves?businessUnitCode=${businessUnitCodeURL}&section=${sectionURL}`
      )
      .then((response) => {
        if (response.data.length !== 0) {
          setShelves(response.data);
        }
      });

    handleButtonClickShelf("1");
  }

  useEffect(() => {
    inicialização();
  }, [businessUnitCodeURL, sectionURL]);

  function handleSquareClick(mac) {
    navigate(`/details/${mac}`);
  }

  return (
    <Container>
      <MDBRow>
        <MDBCol size="10">
          <h3 className="text-start">Visualização por Prateleiras</h3>
        </MDBCol>
        <MDBCol
          size="2"
          onClick={() => {
            if (filterVisible === "none") {
              setFilterVisible("flex");
            } else {
              inicialização();
              setFilterVisible("none");
            }
          }}
        >
          <h3 className="text-end">
            {filterVisible === "none" ? (
              <button
                className="material-symbols-outlined"
                style={{ borderStyle: "none", backgroundColor: "transparent" }}
              >
                filter_alt
              </button>
            ) : (
              <button
                className="material-symbols-outlined"
                style={{ borderStyle: "none", backgroundColor: "transparent" }}
              >
                close
              </button>
            )}
          </h3>
        </MDBCol>
      </MDBRow>
      <Infos>
        <MDBRow className="text-start">
          <MDBCol lg="12">
            <MDBRow>
              <MDBCol md="6" className="text-start">
                <h4>Seção: {sectionURL}</h4>
              </MDBCol>
            </MDBRow>

            <MDBRow
              className="text-start"
              style={{ display: `${filterVisible}` }}
            >
              <MDBCol md="4">
                <h4>Mac:</h4>
                <Input
                  type="text"
                  autoComplete="mac"
                  name="mac"
                  placeholder="Insira o MAC de 12 dígitos"
                  value={mac}
                  onChange={(e) => setMac(e.target.value)}
                />
              </MDBCol>
              <MDBCol md="4">
                <h4>GTIN:</h4>
                <Input
                  type="text"
                  autoComplete="gtin"
                  name="gtin"
                  placeholder="Insira o GTIN de 13 dígitos"
                  value={gtin}
                  onChange={(e) => setGtin(e.target.value)}
                />
              </MDBCol>
              <MDBCol md="4">
                <h4>Situação:</h4>
                <MDBRow>
                  <MDBCol md="6">
                    <ButtonGrey
                      onClick={handleClickCommissioned}
                      label="Comissionadas"
                    />
                  </MDBCol>
                  <MDBCol md="6">
                    <ButtonGrey
                      onClick={handleClickNotCommissioned}
                      label="Não comissionadas"
                    />
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>

            {filterVisible === "none" && (
              <MDBRow className="text-start">
                <MDBCol lg="4" style={{ display: "flex" }}>
                  <h4>Prateleira:</h4>
                  <ButtonSequence
                    numbers={shelves}
                    onButtonClick={handleButtonClickShelf}
                  />
                </MDBCol>
              </MDBRow>
            )}

            <MDBRow className="text-start">
              {status === "Sucesso" && eslsByShelf ? (
                Object.entries(eslsByShelf).map(([level, slots]) => (
                  <MDBRow lg="12">
                    <h5>Nível {level}</h5>
                    {Object.entries(slots).map(([slot, data]) => (
                      <>
                        <h6>Slot {slot}</h6>
                        <MDBRow>
                          {data.map((esl) => (
                            <MDBCol md="6">
                              <ESLsSquare
                                onClick={() => handleSquareClick(esl.mac)}
                                /*style={
                                  esl.commission_status === "K"
                                    ? { backgroundColor: "#F0F9FF" }
                                    : {}
                                }*/
                              >
                                <MDBRow>
                                  <MDBRow>
                                    <MDBCol md="12">
                                      {esl.commission_status === "K" && (
                                        <h5>
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            local_mall
                                          </span>
                                          {esl.product_title}
                                        </h5>
                                      )}
                                    </MDBCol>
                                  </MDBRow>

                                  <MDBRow>
                                    <MDBCol md="9">
                                      <MDBRow>
                                        <MDBCol md="6">
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "5px",
                                              fontSize: "25px",
                                            }}
                                          >
                                            123
                                          </span>
                                          <span>MAC:</span> {esl.mac}
                                        </MDBCol>
                                        <MDBCol md="6">
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "5px",
                                              fontSize: "25px",
                                            }}
                                          >
                                            123
                                          </span>
                                          <span>GTIN:</span> {esl.product_gtin}
                                        </MDBCol>
                                      </MDBRow>
                                      {esl.commission_status === "K" && (
                                        <MDBRow></MDBRow>
                                      )}
                                      {esl.commission_status === "K" && (
                                        <MDBRow>
                                          <MDBCol size="6">
                                            <span
                                              className="material-symbols-outlined"
                                              style={{
                                                marginRight: "12px",
                                                fontSize: "18px",
                                              }}
                                            >
                                              grade
                                            </span>
                                            <span>Avaliação:</span>{" "}
                                            {esl.product_rating}
                                          </MDBCol>
                                          <MDBCol size="6">
                                            <span
                                              className="material-symbols-outlined"
                                              style={{
                                                marginRight: "12px",
                                                fontSize: "18px",
                                              }}
                                            >
                                              attach_money
                                            </span>
                                            <span>Preço:</span>{" "}
                                            {esl.product_price}
                                          </MDBCol>
                                        </MDBRow>
                                      )}
                                      <MDBRow>
                                        <MDBCol md="6">
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "10px",
                                              fontSize: "20px",
                                            }}
                                          >
                                            width
                                          </span>
                                          <span>Tamanho:</span> {esl.size}
                                        </MDBCol>
                                        <MDBCol md="6">
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            priority
                                          </span>
                                          <span>Status:</span>
                                          <strong>
                                            {esl.is_alive === true ? (
                                              <span style={{ color: "green" }}>
                                                {" "}
                                                Com conexão
                                              </span>
                                            ) : (
                                              <span style={{ color: "red" }}>
                                                {" "}
                                                Sem conexão
                                              </span>
                                            )}
                                          </strong>
                                        </MDBCol>
                                      </MDBRow>

                                      <MDBRow>
                                        <MDBCol md="12">
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            link
                                          </span>
                                          <span>Commiss.:</span>
                                          <strong>
                                            {esl.commission_status === "K" ? (
                                              <span
                                                style={{ color: "#006EB7" }}
                                              >
                                                {" "}
                                                Comissionada
                                              </span>
                                            ) : esl.commission_status ===
                                              "P" ? (
                                              <span style={{ color: "yellow" }}>
                                                {" "}
                                                Pendente
                                              </span>
                                            ) : esl.commission_status ===
                                              "H" ? (
                                              <span style={{ color: "red" }}>
                                                {" "}
                                                Erro
                                              </span>
                                            ) : (
                                              <span style={{ color: "green" }}>
                                                {" "}
                                                Disponível
                                              </span>
                                            )}
                                          </strong>
                                        </MDBCol>
                                      </MDBRow>
                                    </MDBCol>
                                    <MDBCol md="3" className="mt-auto mb-auto">
                                      <MDBCol md="12">
                                        <span>
                                          {" "}
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            shelves
                                          </span>
                                          Prateleira:
                                        </span>{" "}
                                        {esl.shelf}
                                      </MDBCol>
                                      <MDBCol md="12">
                                        <span>
                                          {" "}
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            shelf_position
                                          </span>
                                          Nível:
                                        </span>{" "}
                                        {esl.level}
                                      </MDBCol>
                                      <MDBCol md="12">
                                        <span>
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            position_bottom_left
                                          </span>
                                          Slot:
                                        </span>{" "}
                                        {esl.slot}
                                      </MDBCol>
                                      <MDBCol md="12">
                                        <span>
                                          <span
                                            className="material-symbols-outlined"
                                            style={{
                                              marginRight: "12px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            jump_to_element
                                          </span>
                                          Face:
                                        </span>{" "}
                                        {esl.face}
                                      </MDBCol>
                                    </MDBCol>
                                  </MDBRow>
                                </MDBRow>
                              </ESLsSquare>
                            </MDBCol>
                          ))}
                        </MDBRow>
                      </>
                    ))}
                  </MDBRow>
                ))
              ) : (
                <p className="text-center" style={{ marginTop: "5%" }}>
                  Nenhuma ESL encontrada.
                </p>
              )}
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </Infos>
    </Container>
  );
}

export default ESLs;
